import { useTheme } from 'styled-components';

type PropsType = {
  inverted?: boolean;
  overrideStyle?: Record<any, any>;
};

const PlayIcon = ({ inverted, overrideStyle = {} }: PropsType) => {
  const theme = useTheme();
  return (
    <svg style={{ width: '20px', ...overrideStyle }} viewBox="0 0 43 43">
      <defs>
        <ellipse id="PlayIcon-b" cx="21.5" cy="22" rx="21.5" ry="21" />
        <filter
          id="PlayIcon-a"
          width="195.3%"
          height="197.6%"
          x="-47.7%"
          y="-25%"
          filterUnits="objectBoundingBox"
        >
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="10"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="5"
          />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
        </filter>
      </defs>
      <g fill="none">
        <use fill={theme.Grey1} filter="url(#PlayIcon-a)" href="#PlayIcon-b" />
        <use
          fill={overrideStyle.color || (inverted ? theme.white : theme.Grey1)}
          stroke={theme.Grey1}
          strokeOpacity=".1"
          href="#PlayIcon-b"
        />
        <path
          fill={overrideStyle.color || (inverted ? theme.Grey1 : theme.white)}
          d="M29.69 22.5L16.381 30V15z"
          opacity=".977"
        />
      </g>
    </svg>
  );
};

export default PlayIcon;
